
export interface DeleteCard200Response {
  deletedBillingKey?: string;
  message?: string;
  success: boolean;
}
